export default __webpack_public_path__ + "static/media/portal.d44720b4.jpg";